import type { Nullish } from "~/@types/generics"
import { sbComponentSizeGuideSchema } from "~/lib/storyblok/schemas/library/components/size_guide"
import { fetchSbStories } from "~/lib/storyblok/utils/fetch-sb-stories"
import { handleZodSafeParse } from "~/lib/zod/utils/handle-zod-safe-parse"

type TGetSbSizeguideByProductTypeParams = {
  productType: Nullish<string>
  locale: string
}
export async function getSbSizeguideByProductType({ productType, locale }: TGetSbSizeguideByProductTypeParams) {
  if (!productType) return null

  const sizeGuideData = await fetchSbStories({
    starts_with: "globals/size_guides",
    filter_query: {
      tags: {
        any_in_array: `top,${productType},${productType.toLowerCase()}`,
      },
    },
    locale,
  })

  return handleZodSafeParse(sbComponentSizeGuideSchema({ locale }), sizeGuideData.data.stories?.[0]?.content)
}
